import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaMoneyBill, FaTimesCircle, FaFileInvoice } from "react-icons/fa";

const InvoiceDetail = () => {
  const { invoiceNumber } = useParams();
  const [invoice, setInvoiceData] = useState(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const token = localStorage.getItem("token");
        const encodedinvoiceNumber = encodeURIComponent(invoiceNumber);
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/invoice/${encodedinvoiceNumber}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!res.ok) throw new Error("Gagal fetch data invoice");
        const result = await res.json();
        setInvoiceData(result.data);
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    fetchInvoice();
  }, [invoiceNumber]);

  if (!invoice) return <div className="p-4">Loading...</div>;

  const {
    number,
    created_at,
    due_date,
    paid_date,
    amount,
    tax,
    created_by,
    paid_by,
    cancel_by,
    status,
    desc,
    evidence,
  } = invoice;

  const formatDate = (date) =>
    date ? new Date(date).toLocaleString("id-ID") : "-";

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
    {/* LEFT */}
    <div className="bg-white rounded-2xl shadow-lg p-6 space-y-4 border border-gray-100">
      <h2 className="text-xl font-bold text-gray-800 flex items-center justify-between">
        <span className="flex items-center gap-2">
          <FaFileInvoice className="text-green-600" />
          {number}
        </span>
        <span className="ml-2 px-2 py-1 text-white rounded-full bg-green-500 capitalize text-sm shadow">
          {status}
        </span>
      </h2>
  
      <div className="text-sm text-gray-600 space-y-2">
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-blue-500" />
          Dibuat: {formatDate(created_at)}
        </div>
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-yellow-500" />
          Jatuh Tempo: {formatDate(due_date)}
        </div>
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-green-500" />
          Dibayar: {formatDate(paid_date)}
        </div>
      </div>
  
      <div className="pt-2 border-t text-sm text-gray-700 space-y-2">
        <div className="flex items-center gap-2">
          <FaUser className="text-blue-500" />
          <strong>Dibuat oleh:</strong> {created_by || "-"}
        </div>
        <div className="flex items-center gap-2">
          <FaMoneyBill className="text-green-600" />
          <strong>Dibayar oleh:</strong> {paid_by || "-"}
        </div>
        <div className="flex items-center gap-2">
          <FaTimesCircle className="text-red-500" />
          <strong>Dibatalkan oleh:</strong> {cancel_by || "-"}
        </div>
      </div>
  
      <div className="text-sm text-gray-700">
        <strong>Deskripsi:</strong>
        <p className="mt-1 text-gray-800 bg-gray-50 p-2 rounded-md border border-gray-200">
          {desc || "-"}
        </p>
      </div>
  
      <div className="mt-4 border-t pt-4 text-sm space-y-2">
        <div className="flex justify-between">
          <span className="text-gray-600">Subtotal</span>
          <span className="font-medium">Rp {(amount - tax)?.toLocaleString("id-ID")}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Pajak</span>
          <span className="font-medium">Rp {tax?.toLocaleString("id-ID")}</span>
        </div>
        <div className="flex justify-between text-base font-bold text-gray-800">
          <span>Total</span>
          <span>Rp {amount?.toLocaleString("id-ID")}</span>
        </div>
      </div>
    </div>
  
    {/* RIGHT */}
    <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 flex flex-col justify-between">
      <h3 className="text-lg font-semibold mb-4 text-gray-800">Bukti Pembayaran</h3>
      {evidence ? (
        <img
          src={evidence}
          alt="Bukti pembayaran"
          className="w-full max-h-[400px] object-contain border rounded-xl shadow-sm"
        />
      ) : (
        <div className="text-gray-500 italic border border-dashed rounded-xl p-6 text-center bg-gray-50">
          Tidak ada bukti terlampir
        </div>
      )}
    </div>
  </div>
  );
};

export default InvoiceDetail;